// extracted by mini-css-extract-plugin
export default {"editorWidth":"29.7cm","tableWidth":"26.7cm"};